import { render, staticRenderFns } from "./UniversityCardsList.vue?vue&type=template&id=0b260a2d&scoped=true"
import script from "./UniversityCardsList.vue?vue&type=script&lang=ts"
export * from "./UniversityCardsList.vue?vue&type=script&lang=ts"
import style0 from "./UniversityCardsList.vue?vue&type=style&index=0&id=0b260a2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b260a2d",
  null
  
)

export default component.exports